import baseAPI from '@/api/base';
import { EditGuideline, GetGuideline, RegisterGuideline } from '@/dtos/guideline.dto';
import {
  DELETE_GUIDELINE_URL,
  EDIT_GUIDELINE_URL,
  GET_GUIDELINE_URL,
  REGISTER_GUIDELINE_URL,
  TOGGLE_GUIDELINE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Guideline {
  static getGuidelines = async (getGuideline: GetGuideline): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_GUIDELINE_URL, {
      params: getGuideline,
    });
    console.log('response', response);
    return response;
  };

  static registerGuideline = async (
    registerGuideline: RegisterGuideline
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_GUIDELINE_URL, {
      ...registerGuideline,
    });
    console.log('response', response);
    return response;
  };

  static editGuideline = async (editGuideline: EditGuideline): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_GUIDELINE_URL, {
      ...editGuideline,
    });
    return response;
  };

  static toggleGuidelineIsActive = async (
    editGuideline: EditGuideline
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_GUIDELINE_IS_ACTIVE_URL,
      {
        ...editGuideline,
      }
    );
    return response;
  };

  static deleteGuideline = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_GUIDELINE_URL}/${userId}`
    );
    return response;
  };
}

export default Guideline;
